module.exports = __webpack_public_path__ + "img/inventario.74f8731c.png";